import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import Password from '@/views/Password.vue';
import WinLoseMember from '@/views/WinLoseMember.vue';
import UserOnline from '@/views/UserOnline.vue';
import Downline from '@/views/Downline.vue';
import SubAccount from '@/views/SubAccount.vue';
import DepositWithdraw from '@/views/DepositWithdraw.vue';
import SuggestMember from '@/views/SuggestMember.vue';
import store from '@/store';
import Message from '@/views/Message.vue';
import Banner from '@/views/Banner.vue';
import Bet from '@/views/Bet.vue';
import BetCancel from '@/views/BetCancel.vue';
import Payout from '@/views/Payout.vue';
import Recal from '@/views/Recal.vue';
import AddSubAccount from '@/views/AddSubAccount.vue';
import AddAgent from '@/views/AddAgent.vue';
import EditAgent from '@/views/EditAgent.vue';
import AddMember from '@/views/AddMember.vue';
import EditMember from '@/views/EditMember.vue';
import EditSubAccount from '@/views/EditSubAccount.vue';
import SeamlessKey from '@/views/SeamlessKey.vue';
import TransferKey from '@/views/TransferKey.vue';
import GameReport from '@/views/GameReport.vue';
import Bankaccount from '@/views/BankAccount.vue';
import CryptoAccount from '@/views/CryptoAccount.vue';
import Invoice from '@/views/Invoice.vue';
import DocumentApi from '@/views/DocumentApi.vue';
import CurrencyRate from '@/views/CurrencyRate.vue';
import Round from '@/views/Round.vue';
import GameVersion from '@/views/GameVersion.vue';
import SecureCode from '@/views/SecureCode.vue';
import ResetPasswordLog from '@/views/ResetPasswordLog.vue';
import ActivityLog from '@/views/Activity.vue';
import Feature from '@/views/FeatureView.vue';
import CommissionLog from '@/views/CommissionLog.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: {
      name: 'Dashboard',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      guest: true,
      layout: 'auth',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/password',
    name: 'Password',
    component: Password,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/winlosemember',
    name: 'WinLoseMember',
    component: WinLoseMember,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/gamereport',
    name: 'GameReport',
    component: GameReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/deposit-withdraw',
    name: 'DepositWithdraw',
    component: DepositWithdraw,
    meta: {
      requiresAuth: true,
      permKey: 'statement',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/useronline',
    name: 'UserOnline',
    component: UserOnline,
    meta: {
      requiresAuth: true,
      permKey: 'useronline',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/downline',
    name: 'Downline',
    component: Downline,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/subaccount',
    name: 'SubAccount',
    component: SubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/add-subaccount',
    name: 'AddSubAccount',
    component: AddSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/edit-subaccount',
    name: 'EditSubAccount',
    component: EditSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-agent',
    name: 'AddAgent',
    component: AddAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
        'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-agent',
    name: 'EditAgent',
    component: EditAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBAGENT',
        'ADMIN',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-member',
    name: 'AddMember',
    component: AddMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'AGENT',
        'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-member',
    name: 'EditMember',
    component: EditMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
        'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/suggest-member',
    name: 'SuggestMember',
    component: SuggestMember,
    meta: {
      requiresAuth: true,
      permKey: 'suggestion',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/seamless-key',
    name: 'SeamlessKey',
    component: SeamlessKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/transfer-key',
    name: 'TransferKey',
    component: TransferKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/message',
    name: 'Message',
    component: Message,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/banner',
    name: 'Banner',
    component: Banner,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/bet',
    name: 'Bet',
    component: Bet,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/bet-cancel',
    name: 'BetCancel',
    component: BetCancel,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/payout',
    name: 'Payout',
    component: Payout,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/recal',
    name: 'Recal',
    component: Recal,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/bank-account',
    name: 'Bankaccount',
    component: Bankaccount,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/usdt-account',
    name: 'UsdtAccount',
    component: CryptoAccount,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/document-api',
    name: 'Document Api',
    component: DocumentApi,
    meta: {
      requiresAuth: true,
      allow: [
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBAGENT',
        'AGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/currency',
    name: 'Currency Rate',
    component: CurrencyRate,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBAGENT',
        'AGENT',
      ],
    },
  },
  {
    path: '/round',
    name: 'Round',
    component: Round,
    meta: {
      require: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/game-version',
    name: 'GameVersion',
    component: GameVersion,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/secure-code',
    name: 'SecureCode',
    component: SecureCode,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/reset-passlog',
    name: 'Reset Password Log',
    component: ResetPasswordLog,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/activity',
    name: 'ActivityLog',
    component: ActivityLog,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/feature',
    name: 'Feature',
    component: Feature,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'AGENT',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/commission-log',
    name: 'Commission Log',
    component: CommissionLog,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { isAuthenticated, userPermission, role } = store.getters;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      if ((userPermission[to.meta?.permKey] !== 'off'
        && to.meta?.allow.includes(role))
        && (!to.meta.isEditPermKey
        || userPermission[to.meta.isEditPermKey] === 'edit')) {
        next();
        return;
      } else {
        next('/dashboard');
        return;
      }
    }
    next('/login');
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (!isAuthenticated) {
      next();
      return;
    }
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
